import React from 'react'
import { Image } from 'expo-image'
import { StyleSheet, View } from 'react-native'
import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'
import { hex } from '@ui/utils/hex'

export default function Placeholder() {
  return (
    <View style={StyleSheet.absoluteFill}>
      <Image
        contentFit="contain"
        blurRadius={64}
        transition={500}
        style={[
          StyleSheet.absoluteFill,
          {
            borderRadius: 32,
            opacity: 1,
          },
        ]}
        source={require('@/images/video-placeholder.png')}
      />
      <Gradient
        colors={[hex(colors.blue[50], 0.25), hex(colors.blue[100], 0.75)]}
        start={[0, 0]}
        end={[1, 1]}
      />
    </View>
  )
}
